enum TransactionDisplayStatus {
  BOOKED = 'BOOKED',
  RESERVED = 'RESERVED',
}

export default TransactionDisplayStatus;
